import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableModule } from '@angular/material/table';
import {
  FormatDateTimePipe,
  ProductGroupStatistics,
  RolloutPlanStatisticsDto
} from '@ottobock/remote-update/domain';

@Component({
  selector: 'remote-update-feature-remote-update-dashboard-counter-per-target-product-group',
  templateUrl: './counter-per-target-product-group.component.html',
  styleUrl: './counter-per-target-product-group.component.css',
  imports: [MatTableModule, MatPaginatorModule, MatSortModule, FormatDateTimePipe]
})
export class CounterPerTargetProductGroup implements OnChanges {
  @ViewChild(MatTable) table!: MatTable<RolloutPlanStatisticsDto>;

  @Input() rolloutPlanStatics: RolloutPlanStatisticsDto = {
    lastUpdated: '',
    productGroups: []
  };

  data: ProductGroupStatistics[] = [];
  lastUpdated = '';

  ngOnChanges(): void {
    this.data = this.rolloutPlanStatics.productGroups || [];
    this.lastUpdated = this.rolloutPlanStatics.lastUpdated;
  }

  displayedColumns = ['targetProductGroup', 'eligibleTotal', 'eligibleNow', 'offered', 'installed'];
}
